import { createSelector } from '@reduxjs/toolkit';

import convertRenovationTypesToString from 'shared/utils/convertRenovationTypesToString';
import formatDate from 'shared/utils/formatDate';
import searchBy from 'shared/utils/searchBy';
import selectSelf from 'shared/utils/selectSelf';

import { userSpaceRenovationRequestsApi } from './api';
import type { UserSpaceRenovationRequest } from './types';

const emptySpaceRenovationRequestsList: UserSpaceRenovationRequest[] = [];

const userSpaceRenovationRequestsQueryResultSelector =
  userSpaceRenovationRequestsApi.endpoints.getUserSpaceRenovationRequestsList.select();

const selectSpaceRenovationRequestsList = createSelector(
  userSpaceRenovationRequestsQueryResultSelector,
  (response) => response.data ?? emptySpaceRenovationRequestsList
);

export const selectSearchTerm = createSelector(
  selectSelf,
  (state) => state.userSpaceRenovationRequests.searchTerm
);

export const selectSortParams = createSelector(
  selectSelf,
  (state) => state.userSpaceRenovationRequests.sortParams
);

export const selectStatus = createSelector(
  selectSelf,
  (state) => state.userSpaceRenovationRequests.status
);

const selectCooperativeId = createSelector(
  selectSelf,
  (state) => state.settings.current_cooperative
);

const selectCooperativeRelatedSpaceRenovationRequests = createSelector(
  selectCooperativeId,
  selectSpaceRenovationRequestsList,
  (coopId, list) => list.filter(({ Cooperative }) => Cooperative?.Id === coopId)
);

export const selectSearchedSpaceRenovationRequests = createSelector(
  selectCooperativeRelatedSpaceRenovationRequests,
  selectSearchTerm,
  (list, searchTerm) =>
    searchBy(
      list,
      [
        (request) => request.Title ?? '',
        (request) => request.Space?.Name ?? '',
        (request) => convertRenovationTypesToString(request.RenovationTypes),
        (request) => request.EstimatedTiming ?? '',
        (request) => request.Status?.Label ?? '',
        (request) => formatDate(new Date(request.CreatedOn)),
      ],
      searchTerm
    )
);
